import LogoApplePay from "app/components/Logos/LogoApplePay";
import { getRoutePathForView } from "app/helpers/routerPathHelper";
import {
  CashierTransactionTypes,
  NuveiOpenOrderPaymentMethods,
  NuveiPaymentMethods,
} from "app/utils/const";
import { useState } from "react";
import type { IntlShape } from "react-intl";
import { injectIntl } from "react-intl";
import { Route, Switch, useHistory } from "react-router-dom";
import ManageFundingLogoHeader from "../../../components/ManageFundingLogoHeader/ManageFundingLogoHeader";
import NuveiFundingContent from "../components/NuveiFundingContent/NuveiFundingContent";
import "../NuveiFundingScreenDesktop.scss";
import "../NuveiFundingScreenMobile.scss";
import "./ApplePayFundingScreen.scss";
//
const ApplePayFundingScreen = (props: { intl: IntlShape }) => {
  const history = useHistory();
  const { intl } = props;
  const [tab, setTabValue] = useState(CashierTransactionTypes.DEPOSIT);

  const handleSetTab = (tabType: string) => setTabValue(tabType);

  const handleGetTabs = () => {
    const tabTypes = [
      { type: CashierTransactionTypes.DEPOSIT, id: "cashier-deposit" },
      { type: CashierTransactionTypes.WITHDRAW, id: "cashier-withdraw" },
    ];

    return tabTypes.map(({ type, id }) => ({
      title: intl.formatMessage({ id }),
      callback: () => handleSetTab(type),
      isActive: tab === type,
      id,
    }));
  };

  const path = getRoutePathForView();
  const nuveiPath = `${path}apple_pay`;

  return (
    <Switch>
      <Route
        exact
        path={nuveiPath}
        render={() => (
          <div className="applepay-funding">
            <ManageFundingLogoHeader
              history={history}
              getTabs={handleGetTabs()}
              logo={<LogoApplePay />}
            />
            <NuveiFundingContent
              tab={tab}
              paymentMethod={NuveiPaymentMethods.APPLE_PAY}
              openOrderPaymentMethod={NuveiOpenOrderPaymentMethods.APPLE_PAY}
            />
          </div>
        )}
      />
    </Switch>
  );
};

export default injectIntl(ApplePayFundingScreen);
